module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-1.5537a621.png";